import PulseLoader from 'react-spinners/PulseLoader'
import PropTypes from 'prop-types'

import classNames from 'classnames'

const styles = {
  big: { size: 12, margin: 2, className: 'loading_size3' },
  medium: { size: 8, margin: 4, className: '' },
  small: { size: 4, margin: 6, className: 'loading_size2' },
  icon: { size: 4, margin: 2, className: '' },
  lnb: { size: 2, margin: 0, className: '' },
}

const Loading = ({ size = 'medium', color = '#326edc', style = {} }) => {
  const { size: _size, margin, className } = styles[size]
  return (
    <span className="area_loading">
      <span className={classNames('group_loading', className)}>
        <PulseLoader
          size={_size}
          margin={margin}
          color={color}
          css={{ marginTop: -4, ...style }}
        />
        <span className="screen_out">로딩중</span>
      </span>
    </span>
  )
}

Loading.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOf(['big', 'medium', 'small', 'icon', 'lnb']),
  style: PropTypes.object,
}

export default Loading
